import { Label, SectionTitle, PrimaryBtn, OutlineBtn, StatusPill } from '../components/PaymentControls';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Modal, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useEntidadeContext } from '../EntidadeContext';
import ContratoAssinaturaModal from '../components/consultorio/ContratoAssinaturaModal';
import InputMask from 'react-input-mask';
import { QRCodeCanvas } from 'qrcode.react';
import { fluxopayApi } from '../services/fluxopayApi';
import FluxopayFeePassThroughSimulation from '../components/fluxopay/FluxopayFeePassThroughSimulation';
/* ─────────────────────────────────────────────
   MICRO-COMPONENTES VISUAIS (sem lógica)
───────────────────────────────────────────── */

const Icon = ({ d, size = 16, color = 'currentColor', stroke = 2 }) => (
  <svg width={size} height={size} fill="none" stroke={color} viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={stroke} d={d} />
  </svg>
);


const ICONS = {
  contract:  'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  clipboard: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
  tablet:    'M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z',
  check:     'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
  checkSm:   'M5 13l4 4L19 7',
  trash:     'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16',
  plus:      'M12 4v16m8-8H4',
  print:     'M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z',
  award:     'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z',
  tag:       'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z',
  lock:      'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
  x:         'M6 18L18 6M6 6l12 12',
  user:      'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
  calendar:  'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  shield:    'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
};

/* ── estilos base ── */
const inputBase = {
  width: '100%', padding: '8px 12px', borderRadius: '8px',
  border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
  fontFamily: 'inherit', outline: 'none', backgroundColor: '#fff',
  boxSizing: 'border-box', transition: 'border-color .15s, box-shadow .15s',
};
const fh = {
  onFocus: e => { e.target.style.borderColor = '#2563eb'; e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,.1)'; },
  onBlur:  e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; },
};

const isValidCpfCnpj = value => {
  const digits = String(value || '').replace(/\D/g, '');
  if (![11, 14].includes(digits.length) || /^(\d)\1+$/.test(digits)) return false;
  if (digits.length === 11) {
    const calculate = length => {
      let sum = 0;
      for (let i = 0; i < length; i += 1) sum += Number(digits[i]) * (length + 1 - i);
      const remainder = (sum * 10) % 11;
      return remainder === 10 ? 0 : remainder;
    };
    return calculate(9) === Number(digits[9]) && calculate(10) === Number(digits[10]);
  }
  const calculateCnpj = length => {
    const weights = length === 12 ? [5,4,3,2,9,8,7,6,5,4,3,2] : [6,5,4,3,2,9,8,7,6,5,4,3,2];
    const sum = weights.reduce((total, weight, index) => total + Number(digits[index]) * weight, 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };
  return calculateCnpj(12) === Number(digits[12]) && calculateCnpj(13) === Number(digits[13]);
};
/* ─────────────────────────────────────────────
   COMPONENTE PRINCIPAL
───────────────────────────────────────────── */
const PaymentModal = ({ show, handleClose, appointment, allServices, allFuncionarios, onPaymentConfirm, pacientePacotesAtivos: initialPacientePacotesAtivos }) => {

  /* ══════════════════════════════════════════
     TODA A LÓGICA ORIGINAL — SEM ALTERAÇÕES
  ══════════════════════════════════════════ */
  const [additionalValue, setAdditionalValue] = useState(0);
  const [isContractSigned, setIsContractSigned] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);
  const [isAnamneseComplete, setIsAnamneseComplete] = useState(false);
  const [anamneseCode, setAnamneseCode] = useState(null);
  const [showAnamneseCodeModal, setShowAnamneseCodeModal] = useState(false);
  const [isGeneratingAnamnese, setIsGeneratingAnamnese] = useState(false);
  const [contractCode, setContractCode] = useState(null);
  const [additionalValueDescription, setAdditionalValueDescription] = useState('');
  const [paymentSubtotal, setPaymentSubtotal] = useState(0);
  const [paymentTotal, setPaymentTotal] = useState(0);
  const [appointmentServices, setAppointmentServices] = useState([]);
  const { currentEntidade } = useEntidadeContext();
  const [paymentMethod, setPaymentMethod] = useState('dinheiro');
  const [paymentMode, setPaymentMode] = useState('manual');
  const [fluxopayAvailability, setFluxopayAvailability] = useState({ enabled: false, pix_enabled: false, card_enabled: false });
  const [fluxopayMethod, setFluxopayMethod] = useState('pix');
  const [fluxopayInstallments, setFluxopayInstallments] = useState(1);
  const [fluxopaySimulation, setFluxopaySimulation] = useState(null);
  const [fluxopayOrder, setFluxopayOrder] = useState(null);
  const [showFluxopayPixModal, setShowFluxopayPixModal] = useState(false);
  const [showFluxopayCheckoutModal, setShowFluxopayCheckoutModal] = useState(false);
  const [showFluxopayCustomerModal, setShowFluxopayCustomerModal] = useState(false);
  const [isSavingFluxopayCustomer, setIsSavingFluxopayCustomer] = useState(false);
  const [fluxopayCustomerError, setFluxopayCustomerError] = useState('');
  const [fluxopayCustomerForm, setFluxopayCustomerForm] = useState({ name: '', cpf_cnpj: '', email: '', phone: '', address: '', address_number: '', complement: '', province: '', postal_code: '', city: '', state: '' });
  const isFluxopayPending = ['created', 'pending', 'processing'].includes(fluxopayOrder?.status) ||
    (fluxopayOrder?.status === 'paid' && !fluxopayOrder?.pagamento_id) ||
    (!fluxopayOrder && appointment?.payment_status === 'Aguardando Pagamento' && !!appointment?.fluxopay_payment_order_id);
  const [cardFeePercentage, setCardFeePercentage] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [payments, setPayments] = useState([]);
  const [currentPaymentAmount, setCurrentPaymentAmount] = useState('');
  const [totalDebt, setTotalDebt] = useState(0);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [isLoadingCoverage, setIsLoadingCoverage] = useState(false);
  const [coverageDetails, setCoverageDetails] = useState(null);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentApiMessage, setPaymentApiMessage] = useState(null);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authPassword, setAuthPassword] = useState('');
  const [isAuthorizing, setIsAuthorizing] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [isDiscountAuthorized, setIsDiscountAuthorized] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [isValidatingCoupon, setIsValidatingCoupon] = useState(false);
  const [totalServicosJaPagos, setTotalServicosJaPagos] = useState(0);
  const [totalAdicionaisJaPagos, setTotalAdicionaisJaPagos] = useState(0);
  const [totalDescontoJaConcedido, setTotalDescontoJaConcedido] = useState(0);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [lastPaymentData, setLastPaymentData] = useState(null);
  const [receiptCpf, setReceiptCpf] = useState('');
  const [originCommission, setOriginCommission] = useState({ enabled: false, funcionario_id: '' });
  const MAX_DISCOUNT_PERCENTAGE = 10;
  const [showPatientDataModal, setShowPatientDataModal] = useState(false);
  const [isFetchingPatientData, setIsFetchingPatientData] = useState(false);
  const [isUpdatingPatient, setIsUpdatingPatient] = useState(false);
  const [patientForm, setPatientForm] = useState({ nome: '', cpf: '', estado_civil: '', profissao: '', endereco: '', dddcelular: '', celular: '', email: '' });

  const isPatientFormInvalid = useMemo(() => {
    return !patientForm.nome.trim() || !patientForm.cpf.trim() || !patientForm.estado_civil ||
           patientForm.estado_civil === 'Nao informado' || !patientForm.profissao.trim() ||
           !patientForm.endereco.trim() || !patientForm.dddcelular.trim() ||
           !patientForm.celular.trim() || !patientForm.email.trim();
  }, [patientForm]);

  const [comissionedServices, setComissionedServices] = useState({});
  const [initialServiceIds, setInitialServiceIds] = useState(new Set());

  const hasCommissionableEmployees = useMemo(() => {
    if (!allFuncionarios || allFuncionarios.length === 0) return false;
    return allFuncionarios.some(f => f.comissionavel);
  }, [allFuncionarios]);

  const employeesForOriginCommission = useMemo(() => {
    if (!allFuncionarios || allFuncionarios.length === 0) return [];
    return allFuncionarios.filter(f => f.comissionavel_origem);
  }, [allFuncionarios]);

  const areAllInitialServicesSelected = useMemo(() => {
    if (initialServiceIds.size === 0) return true;
    return [...initialServiceIds].every(id => appointmentServices.some(s => s.id === id));
  }, [initialServiceIds, appointmentServices]);

  const paidServiceIds = useMemo(() => {
    if (!appointment?.pagamento) return new Set();
    return new Set(appointment.pagamento
      .filter(p => p.status_pagamento === 'Confirmado')
      .flatMap(p => p.servicos.map(s => s.id)));
  }, [appointment]);

  const handleCommissionChange = (serviceId, isChecked) => {
    setComissionedServices(prev => {
      const newState = { ...prev };
      if (isChecked) { newState[serviceId] = { enabled: true, funcionario_id: appointment?.medico_id || '' }; }
      else { delete newState[serviceId]; }
      return newState;
    });
  };

  const handleServiceValueChange = (serviceId, newValue) => {
    setAppointmentServices(prev => prev.map(s => s.id === serviceId ? { ...s, valor_pago: newValue } : s));
  };

  const handleServiceChange = (service) => {
    if (paidServiceIds.has(service.id)) return;
    const isCurrentlySelected = appointmentServices.some(s => s.id === service.id);
    if (isCurrentlySelected) {
      setAppointmentServices(prev => prev.filter(s => s.id !== service.id));
      setComissionedServices(prev => { const n = { ...prev }; delete n[service.id]; return n; });
    } else {
      setAppointmentServices(prev => [...prev, { ...service, valor_pago: parseFloat(service.valor || 0), quantidade: 1 }]);
    }
  };

  const sortedServices = useMemo(() => {
    if (!allServices) return [];
    return [...allServices].sort((a, b) => {
      const isASelected = appointmentServices.some(s => s.id === a.id);
      const isBSelected = appointmentServices.some(s => s.id === b.id);
      if (isASelected && !isBSelected) return -1;
      if (!isASelected && isBSelected) return 1;
      return a.nome.localeCompare(b.nome);
    });
  }, [allServices, appointmentServices]);

  const initializedAppointmentId = useRef(null);

  const [tiposFicha, setTiposFicha]                   = useState([]);
  const [showTipoFichaModal, setShowTipoFichaModal]   = useState(false);
  const [selectedTipoFichaId, setSelectedTipoFichaId] = useState('');
  const [isLoadingTipos, setIsLoadingTipos]           = useState(false);


  useEffect(() => {
    if (!show) { initializedAppointmentId.current = null; setIsLoadingData(true); return; }
    const initializeModal = async () => {
      if (!appointment) return;
      if (initializedAppointmentId.current === appointment.id) return;
      initializedAppointmentId.current = appointment.id;
      setIsLoadingData(true);
      let consultaDetalhada = null;
      if (appointment.id) {
        try { const r = await axios.get(`/api/consultas/agendamento/${appointment.id}`); consultaDetalhada = r.data.consulta; }
        catch { consultaDetalhada = null; }
      }
      let initialServices = [];
      if (consultaDetalhada && consultaDetalhada.servicos && consultaDetalhada.servicos.length > 0) {
        try {
          const procedimentosInfo = JSON.parse(consultaDetalhada.procedimentos || '[]');
          initialServices = consultaDetalhada.servicos.map(servicoBase => {
            const pd = procedimentosInfo.find(p => p.nome === servicoBase.nome);
            const isPacote = servicoBase.has_active_package;
            const valorTotalItem = isPacote ? 0 : (pd ? parseFloat(pd.valor_unitario || 0) * (parseInt(pd.quantidade, 10) || 1) : parseFloat(servicoBase.valor || 0));
            return { ...servicoBase, valor_pago: valorTotalItem, quantidade: pd?.quantidade || 1, isPacote, active_package_id: servicoBase.active_package_id };
          });
        } catch (e) {
          initialServices = (appointment.servicos || []).map(s => ({ ...s, valor_pago: parseFloat(s.valor || 0) }));
        }
      } else {
        initialServices = (appointment.servicos || []).map(s => ({ ...s, valor_pago: parseFloat(s.valor || 0), quantidade: 1 }));
      }
      let availability = { enabled: false, pix_enabled: false, card_enabled: false };
      try { availability = await fluxopayApi.paymentAvailability(); } catch { availability = { enabled: false, pix_enabled: false, card_enabled: false }; }
      setFluxopayAvailability(availability);
      setAdditionalValue(0); setAdditionalValueDescription('');
      setPaymentMode(availability.enabled ? 'fluxopay' : 'manual');
      setPaymentMethod(availability.enabled ? 'fluxopay' : 'dinheiro');
      setFluxopayMethod(availability.pix_enabled ? 'pix' : 'credit_card'); setFluxopayInstallments(1); setFluxopayOrder(null); setShowFluxopayPixModal(false); setShowFluxopayCheckoutModal(false);
      setCardFeePercentage(0); setDiscountPercentage(0); setPaymentApiMessage(null);
      setComissionedServices({}); setIsDiscountAuthorized(false); setCoverageDetails(null);
      setSelectedPackageId(null); setTotalServicosJaPagos(0); setTotalAdicionaisJaPagos(0);
      setOriginCommission({ enabled: false, funcionario_id: '' });
      setIsContractSigned(!!appointment.has_signed_contract || !!consultaDetalhada?.has_signed_contract);
      setIsAnamneseComplete(false); setCouponCode(''); setAppliedCoupon(null);
      setReceiptCpf(appointment.paciente?.cpf || '');
      setPayments([]); setCurrentPaymentAmount(''); setTotalDebt(0);
      // Aplica os serviços somente após os resets para recalcular subtotal e total com o estado definitivo.
      setAppointmentServices(initialServices);
      setInitialServiceIds(new Set(initialServices.map(s => s.id)));
      setIsLoadingData(false); setLastPaymentData(null);
    };
    initializeModal();
  }, [show, appointment, allServices]);

  useEffect(() => {
    let interval;
    if (showAnamneseCodeModal && anamneseCode) {
      interval = setInterval(async () => {
        try {
          const r = await axios.get(`/api/anamnese/status/${anamneseCode}`);
          if (r.data.status === 'preenchido') { setIsAnamneseComplete(true); setShowAnamneseCodeModal(false); clearInterval(interval); }
        } catch {}
      }, 3000);
    }
    return () => { if (interval) clearInterval(interval); };
  }, [showAnamneseCodeModal, anamneseCode]);

  useEffect(() => {
    if (!show || !fluxopayOrder?.uuid || !['created', 'pending', 'processing'].includes(fluxopayOrder.status)) return undefined;
    let active = true;
    const interval = setInterval(async () => {
      try {
        const order = await fluxopayApi.syncAsaasOrder(fluxopayOrder.uuid);
        if (!active) return;
        setFluxopayOrder(order);
        if (order.status === 'paid' && order.pagamento_id) {
          setShowFluxopayPixModal(false);
          setPaymentApiMessage({ type: 'success', text: 'Pagamento Fluxopay confirmado. A baixa foi recebida!' });
          onPaymentConfirm({ ...appointment, payment_status: 'Pago', fluxopay_payment_order_id: order.id });
          handleClose();
        } else if (['failed', 'cancelled', 'expired'].includes(order.status)) {
          setShowFluxopayPixModal(false);
          setPaymentApiMessage({ type: 'danger', text: 'A cobrança Fluxopay não foi concluída. As outras formas de pagamento foram liberadas.' });
        }
      } catch {
        // Mantém a cobrança bloqueada diante de falha temporária de consulta.
      }
    }, 5000);
    return () => { active = false; clearInterval(interval); };
  }, [show, fluxopayOrder?.uuid, fluxopayOrder?.status]);
  const handleCommissionEmployeeChange = (serviceId, funcionarioId) => {
    setComissionedServices(prev => ({ ...prev, [serviceId]: { ...prev[serviceId], funcionario_id: funcionarioId } }));
  };

  const handleApplyCoupon = async () => {
    if (!couponCode) return;
    setIsValidatingCoupon(true); setPaymentApiMessage(null);
    try {
      const r = await axios.post('/api/cupons/validate', { codigo: couponCode, subtotal: paymentSubtotal, entidade_id: appointment.entidade_id });
      setAppliedCoupon(r.data); setDiscountPercentage(0);
      setPaymentApiMessage({ type: 'success', text: `Cupom ${couponCode} aplicado com sucesso!` });
    } catch (error) {
      setPaymentApiMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao validar cupom.' });
      setAppliedCoupon(null);
    } finally { setIsValidatingCoupon(false); }
  };

  const handleRemoveCoupon = () => { setAppliedCoupon(null); setCouponCode(''); };

  useEffect(() => {
    const subtotal = appointmentServices.reduce((sum, s) => !s.isPacote ? sum + parseFloat(s.valor_pago || 0) : sum, 0);
    setPaymentSubtotal(subtotal);
  }, [appointmentServices]);

  useEffect(() => {
    let isMounted = true;
    const fetchCoverage = async () => {
      const shouldFetch = show && appointment?.paciente?.tp_convenio === 'Convenio' && appointmentServices.length > 0;
      if (shouldFetch) {
        setIsLoadingCoverage(true);
        const serviceIdsForCoverage = appointmentServices.filter(s => !s.isPacote).map(s => s.id);
        if (serviceIdsForCoverage.length === 0) { setIsLoadingCoverage(false); setCoverageDetails(null); return; }
        try {
          const r = await axios.get(`/api/agendamentos/${appointment.id}/cobertura`, { params: { servicos: serviceIdsForCoverage } });
          if (isMounted) {
            if (r.data && Object.keys(r.data).length > 0 && r.data.valor_total_coberto_convenio > 0) setCoverageDetails(r.data);
            else setCoverageDetails(null);
          }
        } catch { if (isMounted) setCoverageDetails(null); }
        finally { if (isMounted) setIsLoadingCoverage(false); }
      } else { setCoverageDetails(null); }
    };
    fetchCoverage();
    return () => { isMounted = false; };
  }, [appointment, show, appointmentServices]);

  const paidAmountPerService = useMemo(() => {
    const paidMap = {};
    if (appointment && appointment.pagamento) {
      appointment.pagamento.forEach(p => {
        if (p.status_pagamento === 'Confirmado' && p.servicos) {
          p.servicos.forEach(s => { const val = parseFloat(s.pivot.valor_servico_no_momento_pagamento || 0); paidMap[s.id] = (paidMap[s.id] || 0) + val; });
        }
      });
    }
    return paidMap;
  }, [appointment]);

  useEffect(() => {
    const pagamentosAnteriores = appointment?.pagamento || [];
    const servicosPagos = appointmentServices.reduce((acc, service) => {
      const valorAtual = service.isPacote ? 0 : parseFloat(service.valor_pago || 0);
      return acc + Math.min(valorAtual, paidAmountPerService[service.id] || 0);
    }, 0);
    const adicionaisPagos = pagamentosAnteriores.reduce((acc, p) => acc + parseFloat(p.valor_adicional || 0), 0);
    setTotalServicosJaPagos(servicosPagos);
    setTotalAdicionaisJaPagos(adicionaisPagos);
    const descontoConcedido = pagamentosAnteriores.reduce((acc, p) => {
      const sub = parseFloat(p.valor_total_servicos || 0) + parseFloat(p.valor_adicional || 0);
      return acc + (sub * (parseFloat(p.percentual_desconto || 0) / 100));
    }, 0);
    setTotalDescontoJaConcedido(descontoConcedido);
    const patientPortion = paymentSubtotal - (coverageDetails ? parseFloat(coverageDetails.valor_total_coberto_convenio || 0) : 0);
    const subtotalWithAdditions = (patientPortion - servicosPagos) + parseFloat(additionalValue || 0);
    let validDiscountPercentage = Math.max(0, parseFloat(String(discountPercentage).replace(/^0+/, '')) || 0);
    if (validDiscountPercentage > 5 && !isDiscountAuthorized) validDiscountPercentage = 5;
    let discountAmount = 0;
    if (validDiscountPercentage > 0) discountAmount = (Math.min(validDiscountPercentage, MAX_DISCOUNT_PERCENTAGE) / 100) * subtotalWithAdditions;
    const amountAfterDiscount = subtotalWithAdditions - discountAmount;
    const couponDiscount = appliedCoupon ? parseFloat(appliedCoupon.valor_desconto) : 0;
    const finalDebt = Math.max(0, amountAfterDiscount - couponDiscount);
    setTotalDebt(finalDebt);
    if (payments.length === 0) setCurrentPaymentAmount(finalDebt.toFixed(2));
  }, [paymentSubtotal, additionalValue, discountPercentage, coverageDetails, appointment, appointmentServices, paidAmountPerService, totalServicosJaPagos, totalAdicionaisJaPagos, totalDescontoJaConcedido, payments.length, isDiscountAuthorized, appliedCoupon]);

  useEffect(() => {
    setPaymentTotal(payments.reduce((acc, p) => acc + p.total_pago, 0));
  }, [payments]);

  const handleAddPayment = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const amount = parseFloat(currentPaymentAmount);
    if (!amount || amount <= 0) return;
    const hasFluxopay = payments.some(p => p.forma_pagamento === 'fluxopay');
    if ((paymentMethod === 'fluxopay' && payments.length > 0) || (paymentMethod !== 'fluxopay' && hasFluxopay)) {
      setPaymentApiMessage({ type: 'warning', text: 'O Fluxopay deve ser utilizado sozinho nesta cobrança. Remova os pagamentos adicionados para trocar a forma.' }); return;
    }
    const currentPaidBase = payments.reduce((acc, p) => acc + p.valor, 0);
    const remainingDebt = Math.max(0, totalDebt - currentPaidBase);
    if (amount > remainingDebt + 0.001) { setPaymentApiMessage({ type: 'warning', text: `O valor (R$ ${amount.toFixed(2)}) excede o restante a pagar (R$ ${remainingDebt.toFixed(2)}).` }); return; }
    setPaymentApiMessage(null);
    let feeAmount = 0;
    if ((paymentMethod === 'credito' || paymentMethod === 'debito') && cardFeePercentage > 0) feeAmount = amount * (parseFloat(cardFeePercentage) / 100);
    const newPayment = { id: Date.now(), forma_pagamento: paymentMethod, valor: amount, taxa_maquininha: parseFloat(cardFeePercentage || 0), valor_taxa: feeAmount, total_pago: amount + feeAmount, fluxopay_payment_method: paymentMethod === 'fluxopay' ? fluxopayMethod : null, installments: paymentMethod === 'fluxopay' && fluxopayMethod === 'credit_card' ? fluxopayInstallments : 1 };
    const updatedPayments = [...payments, newPayment];
    setPayments(updatedPayments);
    if (paymentMethod !== 'fluxopay') { setPaymentMode('manual'); setPaymentMethod('dinheiro'); }
    setCardFeePercentage(0);
    const updatedPaidBase = updatedPayments.reduce((acc, p) => acc + p.valor, 0);
    setCurrentPaymentAmount(Math.max(0, totalDebt - updatedPaidBase).toFixed(2));
  };

  const handleRemovePayment = (id) => {
    const updatedPayments = payments.filter(p => p.id !== id);
    setPayments(updatedPayments);
    setCurrentPaymentAmount(Math.max(0, totalDebt - updatedPayments.reduce((acc, p) => acc + p.valor, 0)).toFixed(2));
  };

  const handleSaveFluxopayCustomer = async () => {
    setFluxopayCustomerError('');
    const digits = value => String(value || '').replace(/\D/g, '');
    let phone = digits(fluxopayCustomerForm.phone);
    if (phone.startsWith('55') && [12, 13].includes(phone.length)) phone = phone.slice(2);
    const cpf = digits(fluxopayCustomerForm.cpf_cnpj);
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fluxopayCustomerForm.email || '');
    if (!fluxopayCustomerForm.name.trim() || phone.length < 10 || !emailValid || !fluxopayCustomerForm.address.trim() || !fluxopayCustomerForm.address_number.trim() || !fluxopayCustomerForm.province.trim() || !fluxopayCustomerForm.city.trim() || !/^[A-Za-z]{2}$/.test(fluxopayCustomerForm.state || '') || digits(fluxopayCustomerForm.postal_code).length !== 8) {
      setFluxopayCustomerError('Preencha nome, e-mail, telefone, endere?o, n?mero, bairro, cidade, UF e CEP para continuar.');
      setPaymentApiMessage({ type: 'warning', text: 'Preencha telefone, endereço, número, bairro e CEP para continuar.' }); return;
    }
    if (cpf.length !== 11 || !isValidCpfCnpj(cpf)) {
      setFluxopayCustomerError('Informe um CPF v?lido. Os d?gitos verificadores n?o conferem.');
      setPaymentApiMessage({ type: 'warning', text: 'Informe um CPF ou CNPJ válido. Os dígitos verificadores não conferem.' }); return;
    }
    setIsSavingFluxopayCustomer(true);
    try {
      await axios.put(`/api/pacientes/${appointment.paciente.id}`, {
        nome: fluxopayCustomerForm.name, cpf, email: fluxopayCustomerForm.email,
        dddcelular: phone.slice(0, 2), celular: phone.slice(2), endereco: fluxopayCustomerForm.address,
        numero: fluxopayCustomerForm.address_number, complemento: fluxopayCustomerForm.complement || null,
        bairro: fluxopayCustomerForm.province, cep: digits(fluxopayCustomerForm.postal_code),
        cidade: fluxopayCustomerForm.city || null, estado: fluxopayCustomerForm.state || null,
      });
      setShowFluxopayCustomerModal(false);
      setFluxopayCustomerError('');
      setPaymentApiMessage({ type: 'success', text: 'Dados de cobrança atualizados. Clique novamente em Gerar cobrança Fluxopay.' });
    } catch (error) {
      const errors = error.response?.data?.errors;
      const text = errors && typeof errors === 'object' ? Object.values(errors).flat().join(' ') : '';
      setFluxopayCustomerError(text || error.response?.data?.message || 'N?o foi poss?vel atualizar os dados do paciente.');
      setPaymentApiMessage({ type: 'danger', text: text || error.response?.data?.message || 'Não foi possível atualizar os dados do paciente.' });
    } finally { setIsSavingFluxopayCustomer(false); }
  };
  const handleSyncFluxopay = async () => {
    if (!fluxopayOrder?.uuid) return;
    setIsProcessingPayment(true); setPaymentApiMessage(null);
    try {
      const order = await fluxopayApi.syncAsaasOrder(fluxopayOrder.uuid);
      setFluxopayOrder(order);
      if (order.status === 'paid' && order.pagamento_id) {
        setShowFluxopayPixModal(false);
        setShowFluxopayCheckoutModal(false);
        setPaymentApiMessage({ type: 'success', text: 'Pagamento Fluxopay confirmado!' });
        onPaymentConfirm({ ...appointment, payment_status: 'Pago', fluxopay_payment_order_id: order.id });
        handleClose();
      } else setPaymentApiMessage({ type: 'info', text: 'O pagamento ainda está aguardando confirmação do provedor.' });
    } catch (error) { setPaymentApiMessage({ type: 'danger', text: error.response?.data?.message || 'Não foi possível atualizar a cobrança Fluxopay.' }); }
    finally { setIsProcessingPayment(false); }
  };
  const executeContractGeneration = async () => {
    try {
      // Usa appointmentServices se disponível, senão usa os serviços do pagamento confirmado
      const servicosParaContrato = appointmentServices.length > 0
        ? appointmentServices
        : (lastPaymentData?.servicos || []);

      const r = await axios.post('/api/contratos/gerar-codigo', {
        agendamento_id: appointment.id,
        servicos: servicosParaContrato.map(s => ({
          nome: s.nome,
          valor: parseFloat(s.valor || 0),
          valor_pago: s.valor_pago ?? s.pivot?.valor_servico_no_momento_pagamento ?? parseFloat(s.valor || 0),
          quantidade: s.quantidade || 1,
        })),
        discount_percentage: discountPercentage,
        applied_coupon: appliedCoupon,
      });
      setContractCode(r.data.codigo);
      setShowContractModal(true);
    } catch {
      setPaymentApiMessage({ type: 'danger', text: 'Erro ao gerar código do contrato.' });
    }
  };

  const handleGenerateContract = async () => {
    if (!appointment.paciente?.id) return;
    setIsFetchingPatientData(true);
    let p = appointment.paciente;
    try {
      const r = await axios.get(`/api/pacientes/${appointment.paciente.id}`);
      p = r.data.paciente || r.data;
      appointment.paciente = { ...appointment.paciente, ...p };
    } catch {
      setPaymentApiMessage({ type: 'danger', text: 'Não foi possível carregar os dados cadastrais do paciente para validação.' });
      setIsFetchingPatientData(false); return;
    } finally { setIsFetchingPatientData(false); }
    const isDataIncomplete = !p.nome || !p.cpf || !p.endereco || !p.dddcelular || !p.celular || !p.email || !p.profissao || !p.estado_civil || p.estado_civil === 'Nao informado';
    if (isDataIncomplete) {
      setPatientForm({ nome: p.nome || '', cpf: p.cpf || '', estado_civil: p.estado_civil || 'Nao informado', profissao: p.profissao || '', endereco: p.endereco || '', dddcelular: p.dddcelular || '', celular: p.celular || '', email: p.email || '' });
      setShowPatientDataModal(true); return;
    }
    await executeContractGeneration();
  };

  const handleGenerateAnamneseCode = async () => {
    setIsGeneratingAnamnese(true);
    try {
      // Busca os tipos de ficha da entidade
      const res = await axios.get(`/api/ficha-anamnese-tipos?entidade_id=${appointment.entidade_id}`);
      const tipos = res.data.tipos || [];
      setTiposFicha(tipos);

      if (tipos.length === 0) {
        // Sem tipos cadastrados: gera anamnese genérica (sem tipo_ficha_id)
        await gerarCodigoAnamnese(null);
      } else if (tipos.length === 1) {
        // Apenas um tipo: já gera direto
        await gerarCodigoAnamnese(tipos[0].id);
      } else {
        // Múltiplos tipos: abre modal de seleção
        setSelectedTipoFichaId(tipos[0].id);
        setShowTipoFichaModal(true);
        setIsGeneratingAnamnese(false); // loading para aqui, retoma no confirm
      }
    } catch {
      setPaymentApiMessage({ type: 'danger', text: 'Erro ao carregar tipos de ficha.' });
      setIsGeneratingAnamnese(false);
    }
  };

  // Função interna que efetivamente chama a API
  const gerarCodigoAnamnese = async (tipoFichaId) => {
    setIsGeneratingAnamnese(true);
    try {
      const r = await axios.post('/api/anamnese/gerar-codigo', {
        agendamento_id: appointment.id,
        ...(tipoFichaId ? { tipo_ficha_id: tipoFichaId } : {}),
      });
      setAnamneseCode(r.data.codigo);
      setShowAnamneseCodeModal(true);
    } catch {
      setPaymentApiMessage({ type: 'danger', text: 'Erro ao gerar código da anamnese.' });
    } finally {
      setIsGeneratingAnamnese(false);
    }
  };

  const handleConfirmTipoFicha = async () => {
    setShowTipoFichaModal(false);
    await gerarCodigoAnamnese(selectedTipoFichaId || null);
  };

  const handleUpdatePatientAndGenerate = async () => {
    if (isPatientFormInvalid) { setPaymentApiMessage({ type: 'warning', text: 'Por favor, preencha todos os campos obrigatórios.' }); return; }
    setIsUpdatingPatient(true);
    try {
      await axios.put(`/api/pacientes/${appointment.paciente.id}`, patientForm);
      appointment.paciente = { ...appointment.paciente, ...patientForm };
      setShowPatientDataModal(false); await executeContractGeneration();
    } catch (error) { setPaymentApiMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao atualizar dados do paciente.' }); }
    finally { setIsUpdatingPatient(false); }
  };

  const handleConfirm = async () => {
    const selectedFluxopayPayment = payments.find(p => p.forma_pagamento === 'fluxopay');
    const isCardPaymentLink = selectedFluxopayPayment?.fluxopay_payment_method === 'credit_card';
    if (!isContractSigned && isCardPaymentLink) {
      setPaymentApiMessage({ type: 'warning', text: 'Pagamento por cart?o ocorre por link. Assine o contrato antes de gerar a cobran?a para comprovar a autoriza??o da transa??o.' });
      await handleGenerateContract();
      return;
    }
    if (!isContractSigned && currentEntidade.exigir_contrato_no_pagamento) { setPaymentApiMessage({ type: 'warning', text: 'O contrato deve ser assinado antes do pagamento.' }); return; }
    if (payments.length === 0) { setPaymentApiMessage({ type: 'warning', text: 'Adicione pelo menos um pagamento.' }); return; }
    const totalPaidBase = payments.reduce((acc, p) => acc + p.valor, 0);
    if (totalPaidBase < totalDebt - 0.01) { setPaymentApiMessage({ type: 'warning', text: `O valor total pago (R$ ${totalPaidBase.toFixed(2)}) é menor que o total a pagar (R$ ${totalDebt.toFixed(2)}).` }); return; }
    setIsProcessingPayment(true); setPaymentApiMessage(null);
    const valorServicosJaPagos = (appointment?.pagamento || []).reduce((acc, p) => acc + parseFloat(p.valor_total_servicos || 0), 0);
    const subtotalParaEstePagamento = Math.max(0, paymentSubtotal - valorServicosJaPagos);
    const discountFactor = 1 - (parseFloat(discountPercentage || 0) / 100);
    const totalServicesValueBeforeCoupon = appointmentServices.reduce((sum, s) => !s.isPacote ? sum + (parseFloat(s.valor_pago || 0) * discountFactor) : sum, 0);
    let couponDiscountFactor = 1;
    if (appliedCoupon && totalServicesValueBeforeCoupon > 0) couponDiscountFactor = Math.max(0, 1 - (parseFloat(appliedCoupon.valor_desconto) / totalServicesValueBeforeCoupon));
    const servicosPagosParaApi = appointmentServices.map(service => {
      const isCommissionable = !!service.pivot?.consulta_id;
      const isEnabled = isCommissionable && !!comissionedServices[service.id]?.enabled;
      let finalValorPago = parseFloat(service.valor_pago || 0) * discountFactor;
      if (!service.isPacote) finalValorPago *= couponDiscountFactor;
      const finalCommissionValue = isEnabled ? (finalValorPago * parseFloat(service.percentual_comissao || 0)) / 100 : 0;
      return { id: service.id, valor: finalValorPago, comissionado: isCommissionable && !!comissionedServices[service.id]?.enabled, valor_comissao: finalCommissionValue, funcionario_id: isCommissionable ? (comissionedServices[service.id]?.funcionario_id || null) : null };
    });
    const pacotesUtilizadosIds = appointmentServices.filter(s => s.active_package_id).map(s => s.active_package_id);
    const subtotalBrutoServicos = appointmentServices.reduce((sum, s) => !s.isPacote ? sum + parseFloat(s.valor_pago || 0) : sum, 0);
    const valorTotalDesconto = (subtotalBrutoServicos * (parseFloat(discountPercentage || 0) / 100)) + (appliedCoupon ? parseFloat(appliedCoupon.valor_desconto) : 0);
    let originCommissionPayload = null;
    if (originCommission.enabled && originCommission.funcionario_id) {
      const valorTotalServicosOriginais = appointmentServices.filter(s => initialServiceIds.has(s.id)).reduce((acc, s) => acc + parseFloat(s.valor_pago || 0), 0);
      originCommissionPayload = { ...originCommission, valor_comissao: valorTotalServicosOriginais * 0.04 };
    }
    const paymentData = {
      agendamento_id: appointment.id, entidade_id: appointment.entidade_id,
      pagamentos: payments.map(({ id, ...rest }) => rest),
      forma_pagamento: payments.length === 1 ? payments[0].forma_pagamento : 'multiplo',
      percentual_taxa_maquininha: payments.length === 1 ? payments[0].taxa_maquininha : 0,
      valor_total_servicos: subtotalBrutoServicos, valor_desconto: valorTotalDesconto,
      servicos_pagos: servicosPagosParaApi, valor_total_pago: paymentTotal,
      valor_adicional: parseFloat(additionalValue || 0), descricao_valor_adicional: additionalValueDescription,
      percentual_desconto: parseFloat(discountPercentage || 0), eh_convenio: !!coverageDetails,
      cupom_id: appliedCoupon ? appliedCoupon.id : null, pacotes_ids: pacotesUtilizadosIds,
      origin_commission: originCommissionPayload,
      valor_coparticipacao_paciente: coverageDetails ? parseFloat(coverageDetails.valor_coparticipacao_paciente) : null,
      valor_coberto_convenio: coverageDetails ? parseFloat(coverageDetails.valor_total_coberto_convenio) : null,
    };
    try {
      const fluxopayPayment = payments.find(p => p.forma_pagamento === 'fluxopay');
      if (fluxopayPayment) {
        const providerMethod = fluxopayPayment.fluxopay_payment_method || 'pix';
        const settlementForma = providerMethod === 'pix' ? 'pix' : 'credito';
        const settlementData = { ...paymentData, pagamentos: paymentData.pagamentos.map(p => ({ ...p, forma_pagamento: settlementForma })), forma_pagamento: settlementForma };
        if (providerMethod === 'credit_card') {
          const patientResponse = await fluxopayApi.patient(appointment.paciente.id);
          const patient = patientResponse?.paciente || patientResponse || {};
          const digits = value => String(value || '').replace(/\D/g, '');
          let phone = digits(`${patient.dddcelular || ''}${patient.celular || ''}`);
          if (digits(patient.celular).length >= 10) phone = digits(patient.celular);
          if (phone.startsWith('55') && [12, 13].includes(phone.length)) phone = phone.slice(2);
          const customerData = {
            name: patient.nome || '', cpf_cnpj: digits(patient.cpf), email: patient.email || '', phone,
            address: patient.endereco || '', address_number: patient.numero || '', complement: patient.complemento || '',
            province: patient.bairro || '', postal_code: digits(patient.cep), city: patient.cidade || '', state: patient.estado || '',
          };
          const missingBillingData = !customerData.name || customerData.cpf_cnpj.length !== 11 || !isValidCpfCnpj(customerData.cpf_cnpj) || !customerData.email || customerData.phone.length < 10 || !customerData.address || !customerData.address_number || !customerData.province || !customerData.city || !/^[A-Za-z]{2}$/.test(customerData.state || '') || customerData.postal_code.length !== 8;
          if (missingBillingData) {
            setFluxopayCustomerForm(customerData);
            setFluxopayCustomerError('');
            setShowFluxopayCustomerModal(true);
            setPaymentApiMessage({ type: 'warning', text: 'Complete os dados de cobrança do paciente para abrir o checkout de cartão.' });
            return;
          }
        }

        const serviceAmountCents = Math.round(totalPaidBase * 100);

        const simulationMatchesPayment =
          fluxopaySimulation &&
          Number(fluxopaySimulation.service_amount_cents) === serviceAmountCents &&
          fluxopaySimulation.payment_method === providerMethod &&
          Number(fluxopaySimulation.installments) === (
            providerMethod === 'credit_card'
              ? Number(fluxopayPayment.installments || 1)
              : 1
          );

        const amountChargedCents =
          simulationMatchesPayment &&
          fluxopaySimulation.fees_passed_to_customer
            ? Number(fluxopaySimulation.gross_amount_cents)
            : serviceAmountCents;
        const order = await fluxopayApi.createAsaasOrder({
          agendamento_id: appointment.id, paciente_id: appointment.paciente.id, payment_method: providerMethod,
          installments: providerMethod === 'credit_card' ? Number(fluxopayPayment.installments || 1) : 1,
          gross_amount_cents: amountChargedCents, discount_amount_cents: 0,
          idempotency_key: `appointment-${appointment.id}-${Date.now()}`,
          metadata: {
            description: `${appointment.paciente?.nome || 'paciente'}`,

            fee_pass_through: {
              enabled: Boolean(
                simulationMatchesPayment &&
                fluxopaySimulation.fees_passed_to_customer
              ),
              service_amount_cents: serviceAmountCents,
              customer_fee_cents:
                simulationMatchesPayment
                  ? Number(fluxopaySimulation.customer_fee_cents || 0)
                  : 0,
              charged_amount_cents: amountChargedCents,
              provider_fee_cents:
                simulationMatchesPayment
                  ? Number(fluxopaySimulation.provider_fee_cents || 0)
                  : 0,
              platform_fee_cents:
                simulationMatchesPayment
                  ? Number(fluxopaySimulation.platform_fee_cents || 0)
                  : 0,
            },

            payment_context: settlementData,
          },
        });
        setFluxopayOrder(order);
        if (providerMethod === 'pix') setShowFluxopayPixModal(true);
        else if (order.metadata?.checkout_url) {
          setShowFluxopayCheckoutModal(true);
        } else {
          throw new Error('O provedor não retornou a URL do checkout seguro.');
        }
        setPaymentApiMessage({ type: 'info', text: 'Cobrança Fluxopay criada. A baixa será confirmada automaticamente após o pagamento.' });
        onPaymentConfirm({ ...appointment, payment_status: 'Aguardando Pagamento', fluxopay_payment_order_id: order.id });
        return;
      }
      const response = await axios.post('/api/pagamentos', paymentData);
      if (response.status === 201) {
        setPaymentApiMessage({ type: 'success', text: 'Pagamento registrado com sucesso!' });
        onPaymentConfirm(response.data.pagamento.agendamento);
        setLastPaymentData(response.data.pagamento);
      } else { setPaymentApiMessage({ type: 'warning', text: `Resposta inesperada do servidor: ${response.status}` }); }
    } catch (error) {
      const responseErrors = error.response?.data?.errors;
      const providerErrors = Array.isArray(responseErrors)
        ? responseErrors.map(item => typeof item === 'string' ? item : item?.description || item?.message).filter(Boolean).join(' ')
        : responseErrors && typeof responseErrors === 'object'
          ? Object.values(responseErrors).flat().map(item => typeof item === 'string' ? item : item?.description || item?.message).filter(Boolean).join(' ')
          : '';
      setPaymentApiMessage({ type: 'danger', text: providerErrors || error.response?.data?.message || error.response?.data?.error || 'Erro ao registrar pagamento. Tente novamente.' });
    } finally { setIsProcessingPayment(false); }
  };

  const handleDiscountChange = (e) => {
    const rawVal = String(e.target.value).replace(/^0+(?=\d)/, '');
    const finalVal = Math.min(Math.max(0, parseFloat(rawVal) || 0), MAX_DISCOUNT_PERCENTAGE);
    if (finalVal > 5 && !isDiscountAuthorized) setShowAuthModal(true);
    setDiscountPercentage(finalVal);
  };

  const handleAuthorizeDiscount = async () => {
    setIsAuthorizing(true); setAuthError(null);
    try {
      await axios.post('/api/authorize-action', { password: authPassword, action_type: 'discount' });
      setIsDiscountAuthorized(true); setShowAuthModal(false); setAuthPassword('');
    } catch (error) { setAuthError(error.response?.data?.message || 'Falha na autorização.'); setAuthPassword(''); }
    finally { setIsAuthorizing(false); }
  };

  const handleServiceValueBlur = (serviceId) => {
    const service = appointmentServices.find(s => s.id === serviceId);
    if (!service) return;
    const originalValue = parseFloat(service.valor || 0);
    let currentValue = parseFloat(String(service.valor_pago).replace(/^0+(?=\d)/, '')) || 0;
    if (currentValue < originalValue) currentValue = originalValue;
    handleServiceValueChange(serviceId, currentValue.toFixed(2));
  };

  const handlePrintReceipt = () => {
    const receiptWindow = window.open('', '_blank');
    const date = new Date().toLocaleDateString('pt-BR');
    const time = new Date().toLocaleTimeString('pt-BR');
    const getStorageUrl = (path) => {
      if (!path) return null;
      let baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '');
      return `${baseUrl}/storage/${path.replace(/^\//, '')}`;
    };
    const logoUrl = currentEntidade?.logo_path ? getStorageUrl(currentEntidade.logo_path) : null;
    const nomeClinica = currentEntidade?.nome || 'CLÍNICA';
    const content = `<html><head><title>Recibo - ${appointment.paciente?.nome}</title><style>body{font-family:'Courier New',monospace;padding:20px;max-width:400px;margin:0 auto}.header{text-align:center;margin-bottom:20px;border-bottom:1px dashed #000;padding-bottom:10px}.header img{max-width:150px;max-height:80px;margin-bottom:10px}.items{width:100%;margin-bottom:15px}.items th{text-align:left;border-bottom:1px dashed #000}.items td{padding:5px 0}.totals{border-top:1px dashed #000;padding-top:10px}.total-row{display:flex;justify-content:space-between;font-weight:bold;margin-top:5px}.footer{text-align:center;margin-top:30px;font-size:12px}@media print{@page{margin:0}body{padding:10px}}</style></head><body><div class="header">${logoUrl ? `<img src="${logoUrl}" alt="${nomeClinica}">` : ''}<h3>${nomeClinica}</h3><p>Recibo de Pagamento</p></div><div class="info"><p><strong>Data:</strong> ${date} ${time}</p><p><strong>Paciente:</strong> ${appointment.paciente?.nome}</p>${receiptCpf ? `<p><strong>CPF:</strong> ${receiptCpf}</p>` : ''}</div><table class="items"><thead><tr><th>Descrição</th><th style="text-align:right">Valor</th></tr></thead><tbody>${appointmentServices.map(s => `<tr><td>${s.nome}${s.isPacote ? ' (Pacote)' : ''}</td><td style="text-align:right">R$ ${parseFloat(s.valor_pago).toFixed(2)}</td></tr>`).join('')}</tbody></table><div class="totals">${payments.map(p => `<div style="display:flex;justify-content:space-between;font-size:14px"><span>${p.forma_pagamento.toUpperCase()}</span><span>R$ ${p.valor.toFixed(2)}</span></div>`).join('')}<div class="total-row"><span>TOTAL PAGO</span><span>R$ ${parseFloat(paymentTotal).toFixed(2)}</span></div></div><div class="footer"><p>Obrigado pela preferência!</p></div></body></html>`;
    receiptWindow.document.write(content); receiptWindow.document.close(); receiptWindow.focus();
    setTimeout(() => { receiptWindow.print(); receiptWindow.close(); }, 500);
  };

  const handleOriginCommissionChange = (isChecked) => {
    setOriginCommission(prev => ({ ...prev, enabled: isChecked, funcionario_id: isChecked ? prev.funcionario_id : '' }));
  };
  const handleOriginCommissionEmployeeChange = (funcionarioId) => {
    setOriginCommission(prev => ({ ...prev, funcionario_id: funcionarioId }));
  };

  if (!appointment) return null;

  const paidBaseTotal = payments.reduce((acc, p) => acc + p.valor, 0);
  const remainingAmount = Math.max(0, totalDebt - paidBaseTotal);

  /* ══════════════════════════════════════════
     RENDER — VISUAL REFATORADO
  ══════════════════════════════════════════ */
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        .pm-modal .modal-content { border-radius: 16px !important; border: none !important; overflow: hidden; font-family: 'Inter','Segoe UI',sans-serif; box-shadow: 0 25px 60px rgba(0,0,0,.18) !important; }
        .pm-modal .modal-header { background: linear-gradient(135deg,#1e3a5f,#2563eb); border: none !important; padding: 18px 22px !important; }
        .pm-modal .modal-body { padding: 20px 22px !important; background: #f8fafc; max-height: 75vh; overflow-y: auto; }
        .pm-modal .modal-footer { background: #f1f5f9; border-top: 1px solid #e5e7eb !important; padding: 12px 22px !important; }
        .pm-modal .btn-close { filter: invert(1) brightness(2) !important; }
        .pm-svc-row:hover { background: #f0f9ff !important; }
        .pm-pay-row:hover { background: #fafbff !important; }
        @keyframes pmFadeIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
        .pm-fade { animation: pmFadeIn .35s ease; }
      `}</style>

      <Modal show={show} onHide={handleClose} size="lg" dialogClassName="pm-modal">

        {/* ── HEADER ── */}
        <Modal.Header closeButton>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '38px', height: '38px', borderRadius: '10px', backgroundColor: 'rgba(255,255,255,.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Icon d={ICONS.contract} size={18} color="#fff" />
            </div>
            <div>
              <div style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#fff' }}>Pagamento de Serviços</div>
              <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: 'rgba(255,255,255,.7)' }}>
                {appointment?.paciente?.nome} · {(() => { const [y, m, d] = (appointment?.data_agendamento || '').split('-'); return `${d}/${m}/${y}`; })()} às {appointment?.hora_marcada?.slice(0, 5)}
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {/* ── LOADING ── */}
          {isLoadingData ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 0', gap: '14px' }}>
              <Spinner animation="border" variant="primary" style={{ width: '32px', height: '32px' }} />
              <span style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280', fontWeight: '500' }}>Carregando detalhes do pagamento...</span>
            </div>

          ) : lastPaymentData ? (
            /* ── TELA DE SUCESSO ── */
              <div className="pm-fade" style={{ textAlign: 'center', padding: '32px 16px' }}>
                <div style={{ width: '72px', height: '72px', borderRadius: '50%', backgroundColor: '#f0fdf4', border: '3px solid #bbf7d0', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                  <Icon d={ICONS.checkSm} size={32} color="#16a34a" stroke={2.5} />
                </div>
                <h4 style={{ fontSize: '20px', fontWeight: '800', color: '#111827', marginBottom: '6px' }}>Pagamento Confirmado!</h4>
                <p style={{ fontSize: `calc(14px * var(--font-scale))`, color: '#6b7280', marginBottom: '28px' }}>
                  O pagamento de <strong style={{ color: '#16a34a' }}>R$ {parseFloat(paymentTotal).toFixed(2)}</strong> foi registrado com sucesso.
                </p>

                <div style={{ maxWidth: '280px', margin: '0 auto 28px' }}>
                  <Label>CPF na Nota (Opcional)</Label>
                  <input
                    style={inputBase} type="text" value={receiptCpf}
                    onChange={e => setReceiptCpf(e.target.value)} placeholder="000.000.000-00"
                    {...fh}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '280px', margin: '0 auto' }}>
                  <PrimaryBtn onClick={handlePrintReceipt} color="#2563eb">
                    <Icon d={ICONS.print} size={14} color="#fff" /> Imprimir Recibo
                  </PrimaryBtn>

                  {/* ── BOTÃO GERAR CONTRATO (só aparece se ainda não foi assinado) ── */}
                  {!isContractSigned && (
                    <PrimaryBtn
                      onClick={handleGenerateContract}
                      loading={isFetchingPatientData}
                      color="#7c3aed"
                    >
                      <Icon d={ICONS.contract} size={14} color="#fff" />
                      {isFetchingPatientData ? 'Validando...' : 'Gerar Contrato'}
                    </PrimaryBtn>
                  )}

                  {/* Se contrato já foi assinado, mostra badge informativo */}
                  {isContractSigned && (
                    <div style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                      padding: '8px 16px', borderRadius: '8px',
                      backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0',
                    }}>
                      <Icon d={ICONS.checkSm} size={14} color="#16a34a" stroke={2.5} />
                      <span style={{ fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600', color: '#16a34a' }}>
                        Contrato já assinado
                      </span>
                    </div>
                  )}

                  <button
                    type="button" onClick={handleClose}
                    style={{ padding: '9px 18px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' }}
                  >
                    Fechar
                  </button>
                </div>
              </div>

          ) : (
            /* ── FORMULÁRIO PRINCIPAL ── */
            <div className="pm-fade">

              {/* Alert de mensagem */}
              {paymentApiMessage && (
                <Alert variant={paymentApiMessage.type} onClose={() => setPaymentApiMessage(null)} dismissible style={{ borderRadius: '10px', fontSize: `calc(13px * var(--font-scale))`, marginBottom: '16px' }}>
                  {paymentApiMessage.text}
                </Alert>
              )}

              {/* ── CONTRATO & ANAMNESE ── */}
              {isFluxopayPending && (
                <Alert variant="info" style={{ borderRadius: '12px', marginBottom: '16px' }}>
                  <div style={{ fontWeight: '800', marginBottom: '4px' }}>Cobrança Fluxopay aguardando pagamento</div>
                  <div style={{ fontSize: '13px' }}>As outras formas de pagamento estão bloqueadas para evitar cobrança duplicada. A liberação ocorrerá após a confirmação ou falha da cobrança.</div>
                  <div style={{ display: 'flex', gap: '8px', marginTop: '10px', flexWrap: 'wrap' }}>
                    {fluxopayOrder?.metadata?.checkout_url && <OutlineBtn onClick={() => setShowFluxopayCheckoutModal(true)} small>Mostrar pagamento no celular</OutlineBtn>}
                    {fluxopayOrder?.uuid && <OutlineBtn onClick={handleSyncFluxopay} disabled={isProcessingPayment} small>Atualizar confirmação</OutlineBtn>}
                  </div>
                </Alert>
              )}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '18px' }}>
                {/* Contrato */}
                <div style={{ backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #bfdbfe', padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                    <div style={{ width: '34px', height: '34px', borderRadius: '8px', backgroundColor: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <Icon d={ICONS.contract} size={16} color="#2563eb" />
                    </div>
                    <div>
                      <div style={{ fontSize: `calc(12px * var(--font-scale))`, fontWeight: '700', color: '#111827' }}>Contrato</div>
                      <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }}>Prestação de Serviços</div>
                    </div>
                  </div>
                  {isContractSigned
                    ? <StatusPill color="green"><Icon d={ICONS.checkSm} size={10} color="#16a34a" stroke={2.5} /> Assinado</StatusPill>
                    : <PrimaryBtn small onClick={handleGenerateContract} loading={isFetchingPatientData} color="#2563eb">
                        <Icon d={ICONS.tablet} size={12} color="#fff" />
                        {isFetchingPatientData ? 'Validando...' : 'Tablet'}
                      </PrimaryBtn>
                  }
                </div>

                {/* Anamnese */}
                <div style={{ backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #a7f3d0', padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                    <div style={{ width: '34px', height: '34px', borderRadius: '8px', backgroundColor: '#f0fdf4', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <Icon d={ICONS.clipboard} size={16} color="#16a34a" />
                    </div>
                    <div>
                      <div style={{ fontSize: `calc(12px * var(--font-scale))`, fontWeight: '700', color: '#111827' }}>Anamnese</div>
                      <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }}>Ficha do Paciente</div>
                    </div>
                  </div>
                  {isAnamneseComplete
                    ? <StatusPill color="green"><Icon d={ICONS.checkSm} size={10} color="#16a34a" stroke={2.5} /> Preenchida</StatusPill>
                    : <PrimaryBtn small onClick={handleGenerateAnamneseCode} loading={isGeneratingAnamnese} color="#16a34a">
                        <Icon d={ICONS.tablet} size={12} color="#fff" />
                        {isGeneratingAnamnese ? 'Gerando...' : 'Tablet'}
                      </PrimaryBtn>
                  }
                </div>
              </div>

              {/* ── SERVIÇOS ── */}
              <SectionTitle>Serviços a Pagar</SectionTitle>
              <div style={{ backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', overflow: 'hidden', marginBottom: '16px', maxHeight: '200px', overflowY: 'auto' }}>
                {sortedServices.map(service => {
                  const appointmentService = appointmentServices.find(s => s.id === service.id);
                  const isOriginalService = appointmentService?.origin === 'agendamento';
                  const isSelected = appointmentServices.some(s => s.id === service.id);
                  const isPacote = appointmentService?.isPacote;
                  const isCommissionable = appointmentService?.origin === 'consulta';
                  const isPaid = paidServiceIds.has(service.id);
                  const selectedService = appointmentServices.find(s => s.id === service.id);
                  const quantidade = selectedService?.quantidade || 1;
                  const valorPago = selectedService?.valor_pago || service.valor;
                  const valorUnitario = quantidade > 0 ? valorPago / quantidade : 0;

                  return (
                    <div
                      key={service.id}
                      className="pm-svc-row"
                      style={{
                        display: 'flex', alignItems: 'center', gap: '10px',
                        padding: '10px 14px', borderBottom: '1px solid #f1f5f9',
                        backgroundColor: isSelected ? '#fafbff' : '#fff',
                        opacity: isPaid ? .6 : 1,
                      }}
                    >
                      {/* Checkbox */}
                      <input
                        type="checkbox" checked={isSelected} disabled={isPaid}
                        onChange={() => handleServiceChange(service)}
                        style={{ width: '16px', height: '16px', accentColor: '#2563eb', cursor: isPaid ? 'not-allowed' : 'pointer', flexShrink: 0 }}
                      />

                      {/* Nome + badges */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: isSelected ? '600' : '400', color: '#111827', display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                          {service.nome}
                          {quantidade > 1 && <span style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }}>(Qtd: {quantidade}, Unit: R$ {valorUnitario.toFixed(2)})</span>}
                          {isPacote && <StatusPill color="blue">Pacote</StatusPill>}
                          {isOriginalService && <StatusPill color="yellow">Original</StatusPill>}
                          {isPaid && <StatusPill color="green">Pago</StatusPill>}
                        </div>
                      </div>

                      {/* Valor editável */}
                      {isSelected && !isPacote && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
                          <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280' }}>R$</span>
                          <input
                            type="number" step="0.01" disabled={isPaid}
                            value={appointmentServices.find(s => s.id === service.id)?.valor_pago || ''}
                            onChange={e => handleServiceValueChange(service.id, e.target.value)}
                            onFocus={e => e.target.select()}
                            onBlur={() => handleServiceValueBlur(service.id)}
                            style={{ ...inputBase, maxWidth: '90px', padding: '5px 8px', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', textAlign: 'right' }}
                            {...fh}
                          />
                        </div>
                      )}
                      {isSelected && isPacote && (
                        <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', flexShrink: 0 }}>R$ 0,00</span>
                      )}

                      {/* Comissão */}
                      {isSelected && !isPacote && isCommissionable && service.percentual_comissao > 0 && hasCommissionableEmployees && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                          <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600', color: '#6b7280', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                            <input
                              type="checkbox"
                              checked={!!comissionedServices[service.id]?.enabled}
                              onChange={e => handleCommissionChange(service.id, e.target.checked)}
                              style={{ accentColor: '#2563eb', width: '13px', height: '13px' }}
                            />
                            Comissão
                          </label>
                          {comissionedServices[service.id]?.enabled && (
                            <select
                              value={comissionedServices[service.id]?.funcionario_id || ''}
                              onChange={e => handleCommissionEmployeeChange(service.id, e.target.value)}
                              style={{ ...inputBase, maxWidth: '130px', padding: '4px 8px', fontSize: `calc(12px * var(--font-scale))`, appearance: 'auto' }}
                              {...fh}
                            >
                              <option value="">Selecione...</option>
                              {allFuncionarios.filter(f => f.comissionavel).map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                            </select>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* ── COMISSÃO ORIGINÁRIA ── */}
              {areAllInitialServicesSelected && employeesForOriginCommission.length > 0 && (
                <div style={{ backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #bbf7d0', padding: '14px 16px', marginBottom: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                    <Icon d={ICONS.award} size={14} color="#16a34a" />
                    <span style={{ fontSize: `calc(12px * var(--font-scale))`, fontWeight: '700', color: '#16a34a', textTransform: 'uppercase', letterSpacing: '.5px' }}>Comissão Originária (Indicação)</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500', color: '#374151', cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        checked={originCommission.enabled}
                        onChange={e => handleOriginCommissionChange(e.target.checked)}
                        style={{ accentColor: '#16a34a', width: '15px', height: '15px' }}
                      />
                      Bonificar pela indicação
                    </label>
                    {originCommission.enabled && (
                      <select
                        value={originCommission.funcionario_id}
                        onChange={e => handleOriginCommissionEmployeeChange(e.target.value)}
                        style={{ ...inputBase, maxWidth: '220px', padding: '6px 10px', fontSize: `calc(13px * var(--font-scale))`, appearance: 'auto' }}
                        {...fh}
                      >
                        <option value="">Selecione o funcionário...</option>
                        {employeesForOriginCommission.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                      </select>
                    )}
                  </div>
                </div>
              )}

              {/* ── RESUMO FINANCEIRO ── */}
              <div style={{ backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', overflow: 'hidden', marginBottom: '16px' }}>
                {/* Subtotal */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 16px', borderBottom: '1px solid #f1f5f9' }}>
                  <span style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280' }}>Subtotal dos Serviços</span>
                  <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#111827' }}>R$ {paymentSubtotal.toFixed(2)}</span>
                </div>

                {/* Desconto já concedido */}
                {totalDescontoJaConcedido > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 16px', borderBottom: '1px solid #f1f5f9', backgroundColor: '#fef2f2' }}>
                    <span style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#dc2626' }}>Desconto Concedido</span>
                    <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#dc2626' }}>- R$ {totalDescontoJaConcedido.toFixed(2)}</span>
                  </div>
                )}

                {/* Já pago — serviços */}
                {totalServicosJaPagos > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 16px', borderBottom: '1px solid #f1f5f9', backgroundColor: '#eff6ff' }}>
                    <span style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#2563eb' }}>Valor Pago (Serviços)</span>
                    <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#2563eb' }}>- R$ {(totalServicosJaPagos - totalDescontoJaConcedido).toFixed(2)}</span>
                  </div>
                )}

                {/* Já pago — adicionais */}
                {totalAdicionaisJaPagos > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 16px', borderBottom: '1px solid #f1f5f9', backgroundColor: '#f0fdf4' }}>
                    <span style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#16a34a' }}>Valor Pago (Adicionais)</span>
                    <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', color: '#16a34a' }}>R$ {totalAdicionaisJaPagos.toFixed(2)}</span>
                  </div>
                )}

                {/* Cobertura convênio */}
                {isLoadingCoverage ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '11px 16px', borderBottom: '1px solid #f1f5f9' }}>
                    <Spinner animation="border" size="sm" style={{ width: '14px', height: '14px' }} />
                    <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280' }}>Verificando cobertura do convênio...</span>
                  </div>
                ) : coverageDetails && (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 16px', borderBottom: '1px solid #f1f5f9' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Icon d={ICONS.shield} size={13} color="#0891b2" />
                        <span style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#0891b2' }}>Coberto pelo Convênio ({appointment.paciente.op_convenio})</span>
                      </div>
                      <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#0891b2' }}>- R$ {parseFloat(coverageDetails.valor_total_coberto_convenio).toFixed(2)}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 16px', borderBottom: '1px solid #f1f5f9', backgroundColor: '#ecfeff' }}>
                      <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', color: '#0e7490' }}>Valor a Pagar (Paciente)</span>
                      <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#0e7490' }}>R$ {(paymentSubtotal - parseFloat(coverageDetails.valor_total_coberto_convenio || 0)).toFixed(2)}</span>
                    </div>
                  </>
                )}
              </div>

              {/* ── VALORES ADICIONAIS ── */}
              <SectionTitle>Valores Adicionais</SectionTitle>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '10px', marginBottom: '16px' }}>
                <div>
                  <Label>Descrição</Label>
                  <input
                    style={inputBase} type="text"
                    placeholder="Ex: Material extra, taxa de urgência"
                    value={additionalValueDescription}
                    onChange={e => setAdditionalValueDescription(e.target.value)}
                    {...fh}
                  />
                </div>
                <div style={{ minWidth: '130px' }}>
                  <Label>Valor (R$)</Label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280' }}>R$</span>
                    <input
                      style={{ ...inputBase, textAlign: 'right', fontWeight: '600' }}
                      type="number" step="0.01" min="0" value={additionalValue}
                      onFocus={e => e.target.select()}
                      onChange={e => { const val = Math.max(0, parseFloat(String(e.target.value).replace(/^0+(?=\d)/, '')) || 0); setAdditionalValue(val); }}
                      {...fh}
                    />
                  </div>
                </div>
              </div>

              {/* ── CUPOM + DESCONTO ── */}
              <SectionTitle>Descontos</SectionTitle>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '16px' }}>
                {/* Cupom */}
                <div>
                  <Label>Cupom de Desconto</Label>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <input
                      style={{ ...inputBase, flex: 1, textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '600' }}
                      type="text" placeholder="Ex: BEMVINDO10"
                      value={couponCode}
                      onChange={e => setCouponCode(e.target.value.toUpperCase())}
                      disabled={!!appliedCoupon || isValidatingCoupon}
                      {...fh}
                    />
                    {appliedCoupon ? (
                      <OutlineBtn small danger onClick={handleRemoveCoupon}>
                        <Icon d={ICONS.x} size={11} color="#dc2626" /> Remover
                      </OutlineBtn>
                    ) : (
                      <PrimaryBtn small onClick={handleApplyCoupon} disabled={!couponCode} loading={isValidatingCoupon} color="#2563eb">
                        <Icon d={ICONS.tag} size={11} color="#fff" />
                        {isValidatingCoupon ? 'Validando...' : 'Aplicar'}
                      </PrimaryBtn>
                    )}
                  </div>
                  {appliedCoupon && (
                    <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                      <StatusPill color="green">
                        <Icon d={ICONS.tag} size={10} color="#16a34a" />
                        - R$ {parseFloat(appliedCoupon.valor_desconto).toFixed(2)}
                      </StatusPill>
                    </div>
                  )}
                </div>

                {/* Desconto % */}
                {!appliedCoupon && (
                  <div>
                    <Label>Desconto (%)</Label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <input
                        style={{ ...inputBase, maxWidth: '100px', textAlign: 'right', fontWeight: '600' }}
                        type="number" step="0.01" min="0" max={MAX_DISCOUNT_PERCENTAGE}
                        value={isDiscountAuthorized ? discountPercentage : Math.min(discountPercentage, 5)}
                        onChange={handleDiscountChange}
                        {...fh}
                      />
                      {discountPercentage > 5 && (
                        isDiscountAuthorized
                          ? <StatusPill color="green"><Icon d={ICONS.checkSm} size={10} color="#16a34a" stroke={2.5} /> Autorizado</StatusPill>
                          : <StatusPill color="yellow"><Icon d={ICONS.lock} size={10} color="#d97706" /> Requer auth</StatusPill>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* ── TOTAL A PAGAR ── */}
              <div style={{ backgroundColor: 'linear-gradient(135deg,#1e3a5f,#2563eb)', background: 'linear-gradient(135deg,#1e3a5f,#2563eb)', borderRadius: '12px', padding: '16px 20px', marginBottom: '18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', color: 'rgba(255,255,255,.8)' }}>Total a Pagar</span>
                <span style={{ fontSize: '22px', fontWeight: '800', color: '#fff' }}>R$ {totalDebt.toFixed(2)}</span>
              </div>

              {/* ── PAGAMENTOS ADICIONADOS ── */}
              <SectionTitle>Pagamentos</SectionTitle>

              {payments.length > 0 && (
                <div style={{ backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', overflow: 'hidden', marginBottom: '12px' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: 'linear-gradient(135deg,#f8fafc,#f1f5f9)' }}>
                        {['Forma', 'Valor', 'Taxa', 'Total', ''].map((h, i) => (
                          <th key={i} style={{ padding: '8px 12px', fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700', color: '#64748b', textTransform: 'uppercase', letterSpacing: '.4px', borderBottom: '2px solid #e2e8f0', textAlign: i > 0 ? 'right' : 'left', whiteSpace: 'nowrap' }}>
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {payments.map(p => (
                        <tr key={p.id} className="pm-pay-row">
                          <td style={{ padding: '9px 12px', fontSize: `calc(13px * var(--font-scale))`, color: '#374151', borderBottom: '1px solid #f1f5f9' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span style={{ fontWeight: '600' }}>{p.forma_pagamento === 'fluxopay' ? (p.fluxopay_payment_method === 'pix' ? 'Fluxopay - PIX' : 'Fluxopay - Cartão ' + (p.installments || 1) + 'x') : p.forma_pagamento.charAt(0).toUpperCase() + p.forma_pagamento.slice(1)}</span>
                              {p.taxa_maquininha > 0 && <StatusPill color="yellow">{p.taxa_maquininha}%</StatusPill>}
                            </div>
                          </td>
                          <td style={{ padding: '9px 12px', fontSize: `calc(13px * var(--font-scale))`, color: '#374151', borderBottom: '1px solid #f1f5f9', textAlign: 'right' }}>R$ {p.valor.toFixed(2)}</td>
                          <td style={{ padding: '9px 12px', fontSize: `calc(13px * var(--font-scale))`, color: '#9ca3af', borderBottom: '1px solid #f1f5f9', textAlign: 'right' }}>R$ {p.valor_taxa.toFixed(2)}</td>
                          <td style={{ padding: '9px 12px', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#16a34a', borderBottom: '1px solid #f1f5f9', textAlign: 'right' }}>R$ {p.total_pago.toFixed(2)}</td>
                          <td style={{ padding: '9px 12px', borderBottom: '1px solid #f1f5f9', textAlign: 'right' }}>
                            <button
                              type="button" onClick={() => handleRemovePayment(p.id)} disabled={isFluxopayPending}
                              style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '26px', height: '26px', borderRadius: '6px', border: '1px solid #fecaca', backgroundColor: '#fef2f2', cursor: 'pointer' }}
                            >
                              <Icon d={ICONS.trash} size={12} color="#dc2626" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr style={{ backgroundColor: '#f8fafc' }}>
                        <td colSpan={3} style={{ padding: '9px 12px', fontSize: `calc(12px * var(--font-scale))`, fontWeight: '700', color: '#64748b', textAlign: 'right', textTransform: 'uppercase', letterSpacing: '.4px' }}>Total Recebido</td>
                        <td style={{ padding: '9px 12px', fontSize: `calc(14px * var(--font-scale))`, fontWeight: '800', color: '#16a34a', textAlign: 'right' }}>R$ {paymentTotal.toFixed(2)}</td>
                        <td />
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}

              {/* ── ADICIONAR PAGAMENTO ── */}
              <div style={{ backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '16px', marginBottom: '4px' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end' }}>
                  {/* Operação integrada ou manual */}
                  <div style={{ minWidth: '210px', flex: '1' }}>
                    <Label>Forma de Pagamento</Label>
                    <select
                      style={{ ...inputBase, appearance: 'auto' }}
                      value={paymentMode}
                      onChange={e => {
                        const mode = e.target.value;
                        setPaymentMode(mode);
                        setPaymentMethod(mode === 'fluxopay' ? 'fluxopay' : 'dinheiro');
                        setCardFeePercentage(0);
                      }}
                      disabled={isFluxopayPending}
                      {...fh}
                    >
                      {fluxopayAvailability.enabled && <option value="fluxopay">Fluxopay integrado</option>}
                      <option value="manual">Outras operadoras — pagamento manual</option>
                    </select>
                  </div>

                  {paymentMode === 'fluxopay' ? (
                    <>
                      <div style={{ minWidth: '170px', flex: '1' }}>
                        <Label>Meio de Pagamento</Label>
                        <select style={{ ...inputBase, appearance: 'auto' }} value={fluxopayMethod} onChange={e => setFluxopayMethod(e.target.value)} disabled={isFluxopayPending} {...fh}>
                          {fluxopayAvailability.pix_enabled && <option value="pix">Pix &mdash; escanear QR Code</option>}
                          {fluxopayAvailability.card_enabled && <option value="credit_card">Cart&atilde;o &mdash; pagamento por link no celular</option>}
                        </select>
                      </div>
                      {fluxopayMethod === 'credit_card' && <div style={{ minWidth: '95px' }}><Label>Parcelas</Label><select style={{ ...inputBase, appearance: 'auto' }} value={fluxopayInstallments} onChange={e => setFluxopayInstallments(Number(e.target.value))} disabled={isFluxopayPending} {...fh}>{Array.from({ length: 12 }, (_, i) => i + 1).map(n => <option key={n} value={n}>{n}x</option>)}</select></div>}
                      {fluxopayMethod === 'credit_card' && <div style={{ flexBasis: '100%', padding: '10px 12px', borderRadius: 10, background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', fontSize: 12 }}>
                        <b>Pagamento por link:</b> o paciente receber&aacute; ou escanear&aacute; o link seguro do Asaas no celular. O link somente ser&aacute; liberado com contrato assinado e cadastro completo.
                      </div>}
                    </>
                  ) : (
                    <div style={{ minWidth: '170px', flex: '1' }}>
                      <Label>Meio de Pagamento</Label>
                      <select style={{ ...inputBase, appearance: 'auto' }} value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)} disabled={isFluxopayPending} {...fh}>
                        <option value="dinheiro">Dinheiro</option>
                        <option value="pix">PIX em outra operadora</option>
                        <option value="debito">Cartão de débito</option>
                        <option value="credito">Cartão de crédito</option>
                      </select>
                    </div>
                  )}
                  {/* Valor */}
                  <div style={{ minWidth: '120px', flex: '1' }}>
                    <Label>Valor (R$)</Label>
                    <input
                      style={{ ...inputBase, textAlign: 'right', fontWeight: '600' }}
                      type="number" step="0.01" min="0"
                      value={currentPaymentAmount}
                      onChange={e => setCurrentPaymentAmount(e.target.value)}
                      placeholder="0,00"
                      {...fh}
                    />
                  </div>

                  {/* Taxa */}
                  {(paymentMethod === 'credito' || paymentMethod === 'debito') && (
                    <div style={{ minWidth: '100px', flex: '0 0 auto' }}>
                      <Label>Taxa (%)</Label>
                      <input
                        style={{ ...inputBase, textAlign: 'right' }}
                        type="number" step="0.01" min="0"
                        value={cardFeePercentage}
                        onChange={e => setCardFeePercentage(e.target.value)}
                        placeholder="0"
                        {...fh}
                      />
                    </div>
                  )}

                  {/* Botão Add */}
                  <PrimaryBtn onClick={handleAddPayment} disabled={isFluxopayPending} color="#2563eb">
                    <Icon d={ICONS.plus} size={14} color="#fff" /> Adicionar
                  </PrimaryBtn>
                </div>

                {/* Restante */}
                {remainingAmount > 0 && (
                  <div style={{ marginTop: '10px', padding: '8px 12px', borderRadius: '8px', backgroundColor: '#fffbeb', border: '1px solid #fde68a', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#92400e' }}>Falta adicionar forma de pagamento:</span>
                    <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '800', color: '#d97706' }}>R$ {remainingAmount.toFixed(2)}</span>
                  </div>
                )}

                <FluxopayFeePassThroughSimulation
                  enabled={
                    paymentMode === 'fluxopay' &&
                    !isFluxopayPending
                  }
                  amount={
                    payments.find(
                      payment => payment.forma_pagamento === 'fluxopay'
                    )?.valor || currentPaymentAmount
                  }
                  paymentMethod={fluxopayMethod}
                  installments={fluxopayInstallments}
                  onChange={setFluxopaySimulation}
                />
              </div>

            </div>
          )}
        </Modal.Body>

        {/* ── FOOTER ── */}
        {!lastPaymentData && (
          <Modal.Footer>
            <button
              type="button" onClick={handleClose} disabled={isProcessingPayment}
              style={{ padding: '9px 20px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', cursor: isProcessingPayment ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}
            >
              Cancelar
            </button>
            {!isLoadingData && (
              <PrimaryBtn onClick={handleConfirm} disabled={isProcessingPayment || isFluxopayPending || payments.length === 0} loading={isProcessingPayment} color="#16a34a">
                <Icon d={ICONS.checkSm} size={14} color="#fff" stroke={2.5} />
                {isProcessingPayment ? 'Processando...' : isFluxopayPending ? 'Aguardando pagamento Fluxopay' : payments.some(p => p.forma_pagamento === 'fluxopay') ? 'Gerar cobrança Fluxopay' : 'Confirmar Pagamento'}
              </PrimaryBtn>
            )}
          </Modal.Footer>
        )}

        {/* ══════════════════════════════════════════
            MODAIS SECUNDÁRIOS — lógica intacta
        ══════════════════════════════════════════ */}

        {/* Modal Autorização de Desconto */}
        <Modal show={showAuthModal} onHide={() => { setShowAuthModal(false); setDiscountPercentage(5); setAuthPassword(''); }} centered backdrop="static" dialogClassName="pm-modal">
          <Modal.Header style={{ background: 'linear-gradient(135deg,#7f1d1d,#dc2626)', border: 'none', padding: '16px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '8px', backgroundColor: 'rgba(255,255,255,.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon d={ICONS.lock} size={15} color="#fff" />
              </div>
              <span style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '700', color: '#fff' }}>Autorização Necessária</span>
            </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
            <p style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280', marginBottom: '16px' }}>Para aplicar um desconto acima de 5%, é necessária a senha de um Gerente.</p>
            {authError && (
              <div style={{ padding: '10px 14px', borderRadius: '8px', backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', fontSize: `calc(13px * var(--font-scale))`, marginBottom: '14px' }}>
                {authError}
              </div>
            )}
            <Label>Senha Gerencial</Label>
            <input
              style={inputBase} type="password" value={authPassword}
              onChange={e => setAuthPassword(e.target.value)}
              onKeyPress={e => e.key === 'Enter' && handleAuthorizeDiscount()}
              autoFocus {...fh}
            />
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: '#f9fafb', border: 'none', padding: '12px 20px' }}>
            <button
              type="button"
              onClick={() => { setShowAuthModal(false); setDiscountPercentage(5); setAuthPassword(''); }}
              disabled={isAuthorizing}
              style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Cancelar
            </button>
            <PrimaryBtn onClick={handleAuthorizeDiscount} disabled={!authPassword} loading={isAuthorizing} color="#dc2626">
              <Icon d={ICONS.checkSm} size={13} color="#fff" stroke={2.5} />
              {isAuthorizing ? 'Autorizando...' : 'Autorizar'}
            </PrimaryBtn>
          </Modal.Footer>
        </Modal>

        {/* Modal Assinatura de Contrato */}
        <ContratoAssinaturaModal
          show={showContractModal}
          onHide={() => setShowContractModal(false)}
          codigo={contractCode}
          agendamentoId={appointment.id}
          onSigned={() => { setIsContractSigned(true); setShowContractModal(false); }}
        />

        {/* Modal Complemento de Dados do Paciente */}
        <Modal show={showPatientDataModal} onHide={() => setShowPatientDataModal(false)} size="lg" centered backdrop="static" dialogClassName="pm-modal">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg,#1e3a5f,#2563eb)', border: 'none', padding: '16px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '8px', backgroundColor: 'rgba(255,255,255,.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon d={ICONS.user} size={15} color="#fff" />
              </div>
              <span style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '700', color: '#fff' }}>Dados Obrigatórios para o Contrato</span>
            </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb' }}>
            <div style={{ padding: '12px 14px', borderRadius: '10px', backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', fontSize: `calc(13px * var(--font-scale))`, marginBottom: '18px' }}>
              Os campos abaixo são necessários para a validade jurídica do contrato e ainda não estão preenchidos no perfil do paciente.
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '12px' }}>
              <div>
                <Label required>Nome Completo</Label>
                <input style={inputBase} value={patientForm.nome} onChange={e => setPatientForm({ ...patientForm, nome: e.target.value })} {...fh} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <Label required>CPF</Label>
                  <InputMask mask="999.999.999-99" value={patientForm.cpf} onChange={e => setPatientForm({ ...patientForm, cpf: e.target.value })}>
                    {inputProps => <input {...inputProps} style={inputBase} />}
                  </InputMask>
                </div>
                <div>
                  <Label required>Estado Civil</Label>
                  <select style={{ ...inputBase, appearance: 'auto' }} value={patientForm.estado_civil} onChange={e => setPatientForm({ ...patientForm, estado_civil: e.target.value })} {...fh}>
                    <option value="Nao informado">Selecione...</option>
                    <option value="Solteiro">Solteiro(a)</option>
                    <option value="Casado">Casado(a)</option>
                    <option value="Divorciado">Divorciado(a)</option>
                    <option value="Viuvo">Viúvo(a)</option>
                  </select>
                </div>
                <div>
                  <Label required>Profissão</Label>
                  <input style={inputBase} value={patientForm.profissao} onChange={e => setPatientForm({ ...patientForm, profissao: e.target.value })} {...fh} />
                </div>
                <div>
                  <Label required>E-mail</Label>
                  <input style={inputBase} type="email" value={patientForm.email} onChange={e => setPatientForm({ ...patientForm, email: e.target.value })} {...fh} />
                </div>
              </div>
              <div>
                <Label required>Endereço Completo</Label>
                <input style={inputBase} placeholder="Rua, número, bairro, cidade - UF" value={patientForm.endereco} onChange={e => setPatientForm({ ...patientForm, endereco: e.target.value })} {...fh} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', gap: '12px' }}>
                <div>
                  <Label required>DDD</Label>
                  <input style={inputBase} maxLength={2} value={patientForm.dddcelular} onChange={e => setPatientForm({ ...patientForm, dddcelular: e.target.value })} {...fh} />
                </div>
                <div>
                  <Label required>Celular</Label>
                  <input style={inputBase} value={patientForm.celular} onChange={e => setPatientForm({ ...patientForm, celular: e.target.value })} {...fh} />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: '#f9fafb', borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
            <button
              type="button" onClick={() => setShowPatientDataModal(false)}
              style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Cancelar
            </button>
            <PrimaryBtn onClick={handleUpdatePatientAndGenerate} disabled={isPatientFormInvalid} loading={isUpdatingPatient} color="#2563eb">
              <Icon d={ICONS.checkSm} size={13} color="#fff" stroke={2.5} />
              {isUpdatingPatient ? 'Salvando...' : 'Salvar e Gerar Contrato'}
            </PrimaryBtn>
          </Modal.Footer>
        </Modal>

        {/* Modal Seleção de Tipo de Ficha */}
        <Modal
          show={showTipoFichaModal}
          onHide={() => setShowTipoFichaModal(false)}
          centered
          dialogClassName="pm-modal"
        >
          <Modal.Header
            closeButton
            style={{ background: 'linear-gradient(135deg,#065f46,#16a34a)', border: 'none', padding: '16px 20px' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '8px', backgroundColor: 'rgba(255,255,255,.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon d={ICONS.clipboard} size={15} color="#fff" />
              </div>
              <span style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '700', color: '#fff' }}>
                Selecionar Tipo de Ficha
              </span>
            </div>
          </Modal.Header>

          <Modal.Body style={{ padding: '24px', backgroundColor: '#f9fafb' }}>
            <p style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280', marginBottom: '16px' }}>
              Escolha qual ficha de anamnese o paciente deve preencher:
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {tiposFicha.map(tipo => (
                <label
                  key={tipo.id}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '12px',
                    padding: '12px 16px', borderRadius: '10px', cursor: 'pointer',
                    border: `2px solid ${String(selectedTipoFichaId) === String(tipo.id) ? (tipo.cor || '#16a34a') : '#e5e7eb'}`,
                    backgroundColor: String(selectedTipoFichaId) === String(tipo.id) ? `${tipo.cor || '#16a34a'}10` : '#fff',
                    transition: 'all .15s',
                  }}
                >
                  <input
                    type="radio"
                    name="tipo_ficha_anamnese"
                    value={tipo.id}
                    checked={String(selectedTipoFichaId) === String(tipo.id)}
                    onChange={() => setSelectedTipoFichaId(tipo.id)}
                    style={{ accentColor: tipo.cor || '#16a34a', width: '16px', height: '16px', flexShrink: 0 }}
                  />
                  {/* Bolinha colorida */}
                  <div style={{
                    width: '12px', height: '12px', borderRadius: '50%',
                    backgroundColor: tipo.cor || '#16a34a', flexShrink: 0,
                  }} />
                  <span style={{
                    fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
                    color: String(selectedTipoFichaId) === String(tipo.id) ? (tipo.cor || '#16a34a') : '#374151',
                  }}>
                    {tipo.nome}
                  </span>
                </label>
              ))}
            </div>
          </Modal.Body>

          <Modal.Footer style={{ backgroundColor: '#f9fafb', borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
            <button
              type="button"
              onClick={() => setShowTipoFichaModal(false)}
              style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Cancelar
            </button>
            <PrimaryBtn
              onClick={handleConfirmTipoFicha}
              disabled={!selectedTipoFichaId}
              loading={isGeneratingAnamnese}
              color="#16a34a"
            >
              <Icon d={ICONS.tablet} size={13} color="#fff" />
              {isGeneratingAnamnese ? 'Gerando...' : 'Gerar Código'}
            </PrimaryBtn>
          </Modal.Footer>
        </Modal>


        {/* Modal Código da Anamnese */}
        <Modal show={showFluxopayCustomerModal} onHide={() => setShowFluxopayCustomerModal(false)} centered backdrop="static" dialogClassName="pm-modal">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg,#1e3a5f,#2563eb)', border: 'none' }}>
            <span style={{ fontWeight: '700', color: '#fff' }}>Dados de cobrança do paciente</span>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f8fafc' }}>
            <Alert variant="info"><b>Pagamento por link.</b> Confirme e corrija os dados abaixo. Eles ser&atilde;o salvos no cadastro do paciente antes que o link seguro do Asaas seja criado.</Alert>
            {fluxopayCustomerError && <Alert variant="danger">{fluxopayCustomerError}</Alert>}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,minmax(0,1fr))', gap: '12px' }}>
              {[
                ['name','Nome completo'], ['cpf_cnpj','CPF'], ['email','E-mail'], ['phone','Telefone com DDD'],
                ['postal_code','CEP'], ['address','Endereço'], ['address_number','Número'], ['complement','Complemento'],
                ['province','Bairro'], ['city','Cidade'], ['state','UF'],
              ].map(([key,label]) => (
                <div key={key} style={{ gridColumn: ['name','address'].includes(key) ? 'span 2' : 'auto' }}>
                  <Label required={['name','cpf_cnpj','email','phone','postal_code','address','address_number','province','city','state'].includes(key)}>{label}</Label>
                  <input style={inputBase} type={key === 'email' ? 'email' : 'text'} value={fluxopayCustomerForm[key] || ''} maxLength={key === 'state' ? 2 : key === 'cpf_cnpj' ? 14 : undefined} onChange={e => setFluxopayCustomerForm(prev => ({ ...prev, [key]: key === 'state' ? e.target.value.toUpperCase() : e.target.value }))} {...fh} />
                </div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <OutlineBtn onClick={() => setShowFluxopayCustomerModal(false)} disabled={isSavingFluxopayCustomer}>Cancelar</OutlineBtn>
            <PrimaryBtn onClick={handleSaveFluxopayCustomer} loading={isSavingFluxopayCustomer}>Salvar dados</PrimaryBtn>
          </Modal.Footer>
        </Modal>
        <Modal show={showFluxopayCheckoutModal} onHide={() => setShowFluxopayCheckoutModal(false)} centered backdrop="static" dialogClassName="pm-modal">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg,#1d4ed8,#2563eb)', border: 'none', padding: '16px 20px' }}>
            <span style={{ fontWeight: '700', color: '#fff' }}>Cart&atilde;o &mdash; pagar pelo celular</span>
          </Modal.Header>
          <Modal.Body style={{ padding: '26px 24px', backgroundColor: '#f8fafc', textAlign: 'center' }}>
            <p style={{ color: '#334155', fontWeight: 700, marginBottom: 6 }}>Como o paciente deseja pagar?</p>
            <p style={{ color: '#64748b', marginBottom: 18 }}>Escaneie o QR Code para abrir o Checkout seguro do Asaas no celular. Os dados do cart&atilde;o n&atilde;o passam pelo Fluxo Cl&iacute;nica.</p>
            {fluxopayOrder?.metadata?.checkout_url ? <>
              <div style={{ display: 'inline-block', padding: 14, background: '#fff', border: '1px solid #bfdbfe', borderRadius: 16, boxShadow: '0 8px 24px rgba(37,99,235,.10)' }}>
                <QRCodeCanvas value={fluxopayOrder.metadata.checkout_url} size={210} level="M" includeMargin />
              </div>
              <div style={{ marginTop: 18, display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
                <OutlineBtn onClick={() => {
                  const phone = String(`${appointment?.paciente?.dddcelular || ''}${appointment?.paciente?.celular || ''}`).replace(/\D/g, '');
                  const recipient = phone ? (phone.startsWith('55') ? phone : `55${phone}`) : '';
                  const message = encodeURIComponent(`Ola! Use este link seguro para concluir o pagamento do atendimento: ${fluxopayOrder.metadata.checkout_url}`);
                  window.open(`https://wa.me/${recipient}?text=${message}`, '_blank', 'noopener,noreferrer');
                }}>Enviar pelo WhatsApp</OutlineBtn>
                <OutlineBtn onClick={async () => {
                  await navigator.clipboard.writeText(fluxopayOrder.metadata.checkout_url);
                  setPaymentApiMessage({ type: 'success', text: 'Link seguro copiado.' });
                }}>Copiar link</OutlineBtn>
                <PrimaryBtn onClick={() => window.open(fluxopayOrder.metadata.checkout_url, '_blank', 'noopener,noreferrer')}>Abrir neste dispositivo</PrimaryBtn>
              </div>
              <div style={{ marginTop: 18, padding: '12px 14px', borderRadius: 10, background: '#eff6ff', color: '#1e40af', fontSize: 12 }}>
                A cobran&ccedil;a continuar&aacute; aguardando nesta tela. Ap&oacute;s o pagamento, o webhook dar&aacute; a baixa automaticamente; use &quot;Atualizar confirma&ccedil;&atilde;o&quot; se desejar consultar agora.
              </div>
              <div style={{ marginTop: 12 }}>
                <PrimaryBtn onClick={handleSyncFluxopay} loading={isProcessingPayment} color="#16a34a">Atualizar confirma&ccedil;&atilde;o</PrimaryBtn>
              </div>
            </> : <Alert variant="warning">O provedor n&atilde;o retornou o link do Checkout desta cobran&ccedil;a.</Alert>}
          </Modal.Body>
        </Modal>
        <Modal show={showFluxopayPixModal} onHide={() => setShowFluxopayPixModal(false)} centered backdrop="static" dialogClassName="pm-modal">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg,#0f766e,#14b8a6)', border: 'none', padding: '16px 20px' }}><span style={{ fontWeight: '700', color: '#fff' }}>Pagamento PIX pelo Fluxopay</span></Modal.Header>
          <Modal.Body style={{ padding: '26px 24px', backgroundColor: '#f8fafc', textAlign: 'center' }}>
            <p style={{ color: '#475569', marginBottom: '16px' }}>Peça ao paciente para escanear o QR Code. A baixa ocorrerá após a confirmação do Asaas.</p>
            {fluxopayOrder?.metadata?.pix?.copy_paste ? <><div style={{ display: 'inline-block', padding: '14px', background: '#fff', border: '1px solid #dbeafe', borderRadius: '16px' }}><QRCodeCanvas value={fluxopayOrder.metadata.pix.copy_paste} size={190} level="M" includeMargin /></div><div style={{ marginTop: '16px', display: 'flex', gap: '8px', justifyContent: 'center' }}><OutlineBtn onClick={() => navigator.clipboard.writeText(fluxopayOrder.metadata.pix.copy_paste)}>Copiar PIX</OutlineBtn><PrimaryBtn onClick={handleSyncFluxopay} loading={isProcessingPayment} color="#16a34a">Atualizar confirmação</PrimaryBtn></div></> : <Alert variant="warning">O provedor não retornou o código PIX desta cobrança.</Alert>}
          </Modal.Body>
        </Modal>
        <Modal show={showAnamneseCodeModal} onHide={() => setShowAnamneseCodeModal(false)} centered dialogClassName="pm-modal">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg,#065f46,#16a34a)', border: 'none', padding: '16px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '8px', backgroundColor: 'rgba(255,255,255,.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon d={ICONS.clipboard} size={15} color="#fff" />
              </div>
              <span style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '700', color: '#fff' }}>Código de Acesso — Anamnese</span>
            </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '28px 24px', backgroundColor: '#f9fafb', textAlign: 'center' }}>
            <p style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280', marginBottom: '20px' }}>
              Peça ao paciente para escanear o QR Code ou digitar o código abaixo no tablet:
            </p>

            <div style={{ display: 'inline-block', padding: '16px', backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e5e7eb', boxShadow: '0 4px 12px rgba(0,0,0,.08)', marginBottom: '20px' }}>
              <QRCodeCanvas
                value={`${window.location.origin}/anamnese/${anamneseCode}`}
                size={180} level="H" includeMargin
              />
              <div style={{ marginTop: '8px', fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', fontWeight: '500' }}>Acesso Instantâneo</div>
            </div>

            <div style={{ fontSize: '28px', fontWeight: '800', color: '#2563eb', letterSpacing: '8px', marginBottom: '16px', fontFamily: 'monospace' }}>
              {anamneseCode}
            </div>

            <div style={{ padding: '10px 14px', borderRadius: '10px', backgroundColor: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', fontSize: `calc(12px * var(--font-scale))` }}>
              Este código expira em 1 hora e serve para identificação do paciente no dispositivo móvel.
            </div>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: '#f9fafb', borderTop: '1px solid #e5e7eb', padding: '12px 20px', justifyContent: 'center' }}>
            <button
              type="button" onClick={() => setShowAnamneseCodeModal(false)}
              style={{ padding: '8px 24px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Fechar
            </button>
          </Modal.Footer>
        </Modal>

      </Modal>
    </>
  );
};

export default PaymentModal;
